import { FC } from 'react'
import { components } from 'react-select'
import { Button, Flex } from '@jisr-hr/ds'
import DSIcon from 'components/DSIcon'
import i18n from 'translations/i18n'

type BanksSelectMenuType = { selectProps: { onAddBankClick?: () => void } }

const BanksSelectMenu: FC<BanksSelectMenuType> = (props) => {
  return (
    <components.Menu {...props}>
      {props.children}
      <Flex style={{ width: '100%', paddingBlock: 8 }}>
        <Button
          variant="tertiary"
          size="sm"
          style={{ background: 'transparent' }}
          label={i18n.t('add_bank_account')}
          iconLeading={<DSIcon name="plus" />}
          type="button"
          onClick={(): void => props.selectProps.onAddBankClick?.()}
        />
      </Flex>
    </components.Menu>
  )
}

export default BanksSelectMenu
